import { Bell, Search, Menu } from "lucide-react"
import { Avatar } from "../ui/Avatar"
import { Button } from "../ui/Button"
import { fr } from "../../locales/fr"
import { useAuth } from "../../context/AuthContext"
import GymSwitcher from "./GymSwitcher"

export default function Navbar({ onMenuClick, title, showMenuOnDesktop = false }) {
  const { user } = useAuth()
  const displayEmail = user?.email || "admin@gymflow.com"

  return (
    <header className="sticky top-0 z-40 flex h-16 items-center justify-between border-b border-border bg-background/95 px-6 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="flex items-center gap-4">
        <Button
          variant="ghost"
          size="icon"
          className={showMenuOnDesktop ? "" : "lg:hidden"}
          onClick={onMenuClick}
        >
          <Menu className="h-5 w-5" />
          <span className="sr-only">{fr.navbar.toggleMenu}</span>
        </Button>
        {title && (
          <h1 className="text-xl font-semibold text-foreground">{title}</h1>
        )}
      </div>

      <div className="flex items-center gap-4">
        <GymSwitcher />

        <div className="relative hidden md:block">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <input
            type="search"
            placeholder={fr.navbar.searchPlaceholder}
            className="h-9 w-64 rounded-lg border border-input bg-background pl-10 pr-4 text-sm placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring"
          />
        </div>

        <Button variant="ghost" size="icon" className="relative">
          <Bell className="h-5 w-5" />
          <span className="absolute right-1.5 top-1.5 h-2 w-2 rounded-full bg-primary" />
          <span className="sr-only">{fr.navbar.notifications}</span>
        </Button>

        <div className="flex items-center gap-3 border-l border-border pl-2">
          <div className="hidden text-right sm:block">
            <p className="text-sm font-medium text-foreground">{user?.name || fr.navbar.adminUser}</p>
            <p className="text-xs text-muted-foreground">{displayEmail}</p>
          </div>
          <Avatar
            fallback={(user?.name || "A").slice(0, 1).toUpperCase()}
            alt={user?.name || fr.navbar.adminUser}
            size="md"
          />
        </div>
      </div>
    </header>
  )
}
